/*
 *   File : unlink-account.js
 *   Author : https://evoqins.com
 *   Description : Unlink account modal component
 *   Integrations : NA
 *   Version : 1.0.0
*/

// packages
import React, { useEffect, useRef, useState } from 'react';

//Custom components
import { Icon } from '../Icon';
import { PrimaryButton, SecondaryButton } from '../Buttons';
import { OTPInput } from '../FormElements';

const UnlinkAccountModal = (props) => {

    const inputRef = useRef(null);

    const [step, setStep] = useState(1);

    const [otpValue, setOtpValue] = useState("");
    const [otpValueError, setOtpValueError] = useState("");
    const [focusedInput, setFocusedInput] = useState(2);
    const [seconds, setSeconds] = useState(30);
    const [timerActive, setTimerActive] = useState(false);

    useEffect(() => {
        setOtpValueError("");
    }, [otpValue]);

    useEffect(() => {
        let timer;
        if (timerActive && seconds > 0) {
            timer = setInterval(() => {
                setSeconds((prev) => prev - 1);
            }, 1000);
        } else if (seconds === 0) {
            setTimerActive(false);
            setSeconds(30);
        }

        return () => clearInterval(timer);
    }, [timerActive, seconds]);

    // handle close modal
    const _handleCloseModal = () => {
        var button = document.getElementById("unlink-modal-close");
        button.click();
        props.handleClose();

        setTimeout(() => {
            setStep(1);
            setOtpValue("");
            setOtpValueError("");
        }, 200);

    };


    // handle success modal
    const _handleSuccess = () => {
        _handleCloseModal();
        props.handleSuccess();

        setTimeout(() => {
            setStep(1);
        }, 200);
    };

    // handle unlink flow 
    const _handleUnlinkFlow = (step) => {
        if (step === 2) {
            setFocusedInput(2);
            setTimerActive(true);
            setSeconds(30);
            setStep(step);
        } else if (step === 3) {
            if (otpValue.length < 4) {
                setOtpValueError("Please enter received OTP");
                return;
            }
            setStep(step);
            setOtpValue("");
        }
    };

    //handle Otp change
    const _handleChangeOTP = (value) => {
        setOtpValue(value);
    };

    // handle resend OTP 
    const _handleResendOtp = () => {
        setOtpValue("");
        setFocusedInput(2);
        setTimerActive(true);
        setSeconds(30);
    };


    return (
        <div className="modal fade"
            id="unlink-modal"
            data-bs-backdrop="static"
            data-bs-keyboard="false"
            tabIndex="-1"
            aria-labelledby="unlinkModalLabel"
            aria-hidden="true">

            <div className={`modal-dialog modal-dialog-centered modal-dialog-scrollable border-radius-28 `}>
                <span id='unlink-modal-close' className='d-none' data-bs-dismiss="modal"></span>
                <div className="modal-content border-radius-28 overflow-hidden border-0 e-bg-white-dark">

                    {step === 1 ?
                        <>
                            {/* modal header */}
                            <div className="modal-header border-0 justify-content-between align-items-center padding-32px-lr padding-32px-top pb-3">
                                <h6 className='mb-0 e-text-chinese-black e-primary-font e-font-16 e-font-weight-600 line-height-24px'>
                                    Unlink account
                                </h6>
                                <Icon icon='close'
                                    size="1.125rem"
                                    className="d-flex cursor-pointer"
                                    onClick={_handleCloseModal} />
                            </div>

                            {/* Modal body */}
                            <div className='modal-body py-2 padding-32px-lr'>
                                <p className='mb-0 e-text-dark-gray e-primary-font e-font-16 e-font-weight-400 line-height-20px'>
                                    To unlink this account, an OTP will be sent to the user for confirmation.
                                </p>
                            </div>

                            {/* Modal footer */}
                            <div className='modal-footer border-0 pt-4 padding-32px-lr padding-32px-bottom gap-4'>
                                <SecondaryButton name="Cancel"
                                    paddingBlock="py-3 padding-54px-lr"
                                    onClick={_handleCloseModal} />
                                <PrimaryButton name="Send OTP"
                                    paddingBlock="py-3 padding-60px-lr"
                                    onClick={() => _handleUnlinkFlow(2)} />
                            </div>
                        </>
                        :
                        // OTP verification 
                        step === 2 ?
                            <>
                                {/* modal header */}
                                <div className="modal-header border-0 justify-content-between align-items-center padding-32px-lr padding-32px-top pb-3">
                                    <h6 className='mb-0 e-text-chinese-black e-primary-font e-font-16 e-font-weight-600 line-height-24px'>
                                        OTP verification
                                    </h6>
                                    <Icon icon='close'
                                        size="1.125rem"
                                        className="d-flex cursor-pointer"
                                        onClick={_handleCloseModal} />
                                </div>

                                {/* Modal body */}
                                <div className='modal-body py-2 padding-32px-lr'>
                                    {/* OTP input */}
                                    <OTPInput label="Enter otp sent to the user"
                                        required={true}
                                        ref={inputRef}
                                        value={otpValue}
                                        spellCheck="false"
                                        error={otpValueError}
                                        focusedInput={focusedInput}
                                        onFocus={() => setFocusedInput(2)}
                                        onBlur={() => setFocusedInput(0)}
                                        onKeyPress={() => _handleUnlinkFlow(3)}
                                        onChange={_handleChangeOTP} />
                                    <p className='pt-3 mt-1 mb-0 e-text-taupe-gray  e-primary-font e-font-14 e-font-weight-400 line-height-18px'>
                                        Didn’t get code yet?
                                        <span className={`${timerActive ? 'pe-none' : ''} ps-1 e-text-blue-violet text-decoration-hover-underline cursor-pointer`}
                                            onClick={_handleResendOtp}>
                                            {timerActive ? `Resend OTP in ${seconds}s` : 'Resend OTP'}
                                        </span>
                                    </p>
                                </div>

                                {/* Modal footer */}
                                <div className='modal-footer border-0 pt-4 padding-32px-lr padding-32px-bottom gap-4'>
                                    <SecondaryButton name="Cancel"
                                        paddingBlock="py-3 padding-54px-lr"
                                        onClick={_handleCloseModal} />
                                    <PrimaryButton name="Verify & continue"
                                        paddingBlock="py-3 padding-32px-lr"
                                        onClick={() => _handleUnlinkFlow(3)} />
                                </div>
                            </>
                            :
                            // Unlinked successfully 
                            <>
                                {/* modal header */}
                                <div className="modal-header border-0 justify-content-between align-items-center padding-32px-lr padding-32px-top pb-3">
                                    <h6 className='mb-0 e-text-chinese-black e-primary-font e-font-16 e-font-weight-600 line-height-24px'>
                                        Unlinked successfully
                                    </h6>
                                    <Icon icon='close'
                                        size="1.125rem"
                                        className="d-flex cursor-pointer"
                                        onClick={_handleSuccess} />
                                </div>

                                {/* Modal body */}
                                <div className='modal-body py-2 padding-32px-lr'>
                                    <p className='mb-0 e-text-dark-gray e-primary-font e-font-16 e-font-weight-400 line-height-20px'>
                                        The account has been successfully unlinked .
                                    </p>
                                </div>

                                {/* Modal footer */}
                                <div className='modal-footer border-0 pt-4 padding-32px-lr padding-32px-bottom gap-4'>
                                    <SecondaryButton name="OK"
                                        paddingBlock="py-3 padding-68px-lr"
                                        onClick={_handleSuccess} />
                                </div>
                            </>
                    }
                </div>
            </div>
        </div>
    )
}

export default UnlinkAccountModal;
